import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["theme", "css", "__css", "sx"],
  _excluded2 = ["baseStyle"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { shouldForwardProp } from "./chunk-NAGWYFCH.mjs";

// src/system.ts
import { useColorMode } from "@chakra-ui/color-mode";
import { css, isStyleProp } from "@chakra-ui/styled-system";
import { filterUndefined, objectFilter, runIfFn } from "@chakra-ui/utils";
import { assignAfter } from "@chakra-ui/object-utils";
import createStyled from "@emotion/styled";
import React from "react";
var _a;
var emotion_styled = (_a = createStyled.default) != null ? _a : createStyled;
var toCSSObject = function toCSSObject(_ref) {
  var baseStyle = _ref.baseStyle;
  return function (props) {
    var theme = props.theme,
      cssProp = props.css,
      __css = props.__css,
      sx = props.sx,
      rest = _objectWithoutProperties(props, _excluded);
    var styleProps = objectFilter(rest, function (_, prop) {
      return isStyleProp(prop);
    });
    var finalBaseStyle = runIfFn(baseStyle, props);
    var finalStyles = assignAfter({}, __css, finalBaseStyle, filterUndefined(styleProps), sx);
    var computedCSS = css(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};
function styled(component, options) {
  var _ref2 = options != null ? options : {},
    baseStyle = _ref2.baseStyle,
    styledOptions = _objectWithoutProperties(_ref2, _excluded2);
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  var Component = emotion_styled(component, styledOptions)(styleObject);
  var chakraComponent = React.forwardRef(function ChakraComponent(props, ref) {
    var _useColorMode = useColorMode(),
      colorMode = _useColorMode.colorMode,
      forced = _useColorMode.forced;
    return React.createElement(Component, _objectSpread({
      ref: ref,
      "data-theme": forced ? colorMode : void 0
    }, props));
  });
  return chakraComponent;
}
export { toCSSObject, styled };